import { Arguments, MutatorCallback, useSWRConfig } from 'swr'

export const useMutationUpdate = () => {
  const { mutate } = useSWRConfig()
  return <T>(key: Arguments, updateFn: MutatorCallback<T>) =>
    mutate(key, updateFn, { revalidate: false })
}
